import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db, hasFirebaseConfig } from "../firebase";

/**
 * Firestore collection listener with optional where clauses.
 * @param {string} path
 * @param {{ where?: Array<[field, op, value]>, key?: any }} options
 */
export function useFirestoreCollection(path, options = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const whereKey = (options.where || [])
    .map((w) => `${w[0]}${w[1]}${w[2]}`)
    .join("|");

  useEffect(() => {
    if (!hasFirebaseConfig || !db) {
      setError(new Error("missing-config"));
      setLoading(false);
      return;
    }

    setLoading(true);
    const constraints = (options.where || []).map((w) =>
      where(w[0], w[1], w[2])
    );
    const q = query(collection(db, path), ...constraints);
    const unsub = onSnapshot(
      q,
      (snap) => {
        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setData(docs);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error(`onSnapshot(${path}) error`, err);
        setError(err);
        setLoading(false);
      }
    );
    return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, options.key, whereKey]);

  return { data, loading, error };
}
